import type { MessageType, PushType } from "@lib/campaignMessageTypeConstants";
import { isPushType } from "@lib/campaignMessageTypeConstants";

/** Push platforms present in a loosely typed message-type list, in first-seen order. */
export const pushPlatformsIn = (messageTypes: readonly (MessageType | null | undefined)[]): Set<PushType> =>
  new Set(
    messageTypes.filter((messageType): messageType is PushType => (messageType ? isPushType(messageType) : false))
  );
